var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 65",
    style: {
      enableBackground: "new 0 0 65 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F7A152;}\n\t.st1{fill:#FF7F00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000033345841147505438880000003627440905231183495_",
    className: "st0",
    d: "M21.1,11.8c-0.7,0.4-1.4,0.8-2,1.2 C9.9,19,6.1,30.1,9,40.2l5.9-2.7c-1.2-2.7-1.8-5.7-1.8-8.8C13,21.9,16.2,15.8,21.1,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000176732077846495398070000007184813077955339708_",
    className: "st0",
    d: "M56.5,28.7c0,12-9.7,21.7-21.7,21.7 c-6.1,0-11.6-2.5-15.6-6.6L1.2,46.4l2.4,0.3c5.7,0.7,11.1,2.6,15.9,5.6c7.8,4.9,18.1,5.1,26.3-0.3c9-5.9,12.8-16.6,10.3-26.5 C56.4,26.6,56.5,27.6,56.5,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000044890380721905322350000000404411382196974748_",
    className: "st1",
    d: "M54.6,19.9l9.2-1.3l-0.5-0.1 c-3.8-0.4-7.5-1.4-11-2.7c-2.6-1-5-2.1-7.4-3.5c-7.1-4.2-16.1-4.6-23.7-0.6c-5,4-8.1,10.1-8.1,16.9c0,3.1,0.7,6.1,1.8,8.8l10.5-4.8 l-5.2-8c0.2,0,0.5-0.1,0.7-0.1l0,0L54.6,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000168119152655975461860000014698246667674813075_",
    className: "st1",
    d: "M34.7,50.5c12,0,21.7-9.7,21.7-21.7 c0-1.1-0.1-2.2-0.2-3.2c-0.1-0.2-0.1-0.5-0.2-0.7l-16.4,7.4l5.2,8c-0.2,0-0.5,0.1-0.7,0.1l0,0l-25,3.5 C23.1,47.9,28.6,50.5,34.7,50.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.3edee50b1b93c1f2e4d2c09e89e331ea.svg";
export { ForwardRef as ReactComponent };